import { useCallback, useEffect, useState } from "react";

export default function useIsVisible(onVisibleCallback: () => void) {
    const [isVisible, setVisible] = useState<boolean>(false);
    const [node, setNode] = useState<HTMLElement | null>(null);

    const ref = useCallback((node: HTMLElement | null) => {
        setNode(node)
    }, [])

    useEffect(() => {
        if (!node) {
            return;
        }
        const observer = new IntersectionObserver(
            ([entry]) => {
                setVisible(entry.isIntersecting);
                if (entry.isIntersecting) {
                    onVisibleCallback();
                    
                }
            }, {threshold : 0.2});

        observer.observe(node);

        requestAnimationFrame(() => {
            const rect = node.getBoundingClientRect();
            if (!rect) return;
            const isInView = (
                rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth
            );
            setVisible(isInView);
        })

        return () => {
            if (node)
                observer.unobserve(node);
        }; 
    }, [node]);

    return [isVisible, ref] as const;
}
